import DynamicQuizPage from './DynamicQuizPage';
export default DynamicQuizPage;

